import { createContext } from "react";
import { makeAutoObservable, observable  } from "mobx";
import { accountService } from "../services/accountsService";

class AccountStore {
  constructor() {
    makeAutoObservable(this);
  }

  isloading = false;
  isloaded = false;
  isworking = false;
  accountRequests = observable.map({});
  showRejectRequestDialog = false;
  selectedTab = "1";
  selReqItem = {};
  users = observable.map({});
  isloadingUsers = false;
  hasloadedUsers = false;
  showLockOutDialog = false;
  selectedUser = {};
  userCommandBarDisabled = true;

  async getAllNewRequests() {
    try {
      this.isloading = true;
      let retval = [];
      if (!this.isloaded) {
        retval = await accountService.getAllNewRequests();
        this.accountRequests.clear();

        retval.forEach((req) => {
          this.accountRequests.set(req.accountRegisterId, req);
        });
        this.isloaded = true;
      }
    } catch (error) {
      throw error;
    }
  }

  async approveReject(data) {
    try {
      this.isworking = true;
      const retval = await accountService.approveRejectRequest({ ...data });
      this.accountRequests.delete(retval.requestId);
      this.hasloadedUsers = false;
      return retval;
    } catch (error) {
      throw error;
    }
  }

  async loadAllUsers() {
    try {
      if (!this.hasloadedUsers) {
        this.isloadingUsers = true;
        const res = await accountService.getAllUsers();
        this.users.clear();
        res.forEach((user) => {
          this.users.set(user.id, user);
        });
        this.hasloadedUsers = true;
        this.isloadingUsers = false;
      }
    } catch (error) {
      throw error;
    }
  }

  async toggleAccess(access, id) {
    try {
      const res = await accountService.toggleAccess(access, id);

      const user = this.users.get(id);
      this.users.set(id, { ...user, isEnabled: res.access });
    } catch (error) {
      throw error;
    }
  }

  async deleteUser(id) {
    try {
      await accountService.deleteUser(id);

      this.users.delete(id);
    } catch (error) {
      throw error;
    }
  }
}


export default createContext(new AccountStore());

